import React from 'react';
import { useStyles } from './datepicker_base.styles';

type DatepickerPanelWrapperProps = {
  className?: string;
  dataTestId?: string;
  panel: React.ReactNode;
};
export const DatepickerPanelWrapper = ({ className, dataTestId, panel }: DatepickerPanelWrapperProps) => {
  const styles = useStyles();
  return (
    <div className={`${styles.root} ${className}`} data-testid={dataTestId}>
      {panel}
    </div>
  );
};
